import styled, { css } from "styled-components";
import { device } from "../../constants";

const Container = styled.div`
  background-color: var(--white);
  padding: var(---verticalMargin);
  flex-direction: row;
  justify-content: center;
  align-items: center;
  /* width: 650px; */
  /* height: 450px; */
  padding: var(--verticalMargin);
  position: relative;
`;

const SpaceBetween = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  /* width: 800px;
  height: 500px; */
`;

const FlexEnd = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  /* width: 800px;
  height: 500px; */
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 150px;
`;

const SwitchContainer = styled.div`
  margin: 20px 0;
  width: 150px;
  display: flex;
  justify-content: space-between;
`;

const CardHeader = styled.div`
  font-size: 20px;
`;

const TableContainer = styled.div`
  margin-top: 20px;
`;

const TableButtonsContainer = styled.div`
  height: 35px;
`;

const Dot = styled.div`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  ${(props) =>
    props.color &&
    css`
      background-color: ${props.color};
    `}
`;

const BoxContainer = styled.div`
  /* padding: var(---space); */
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 200px;
  /* border: 1px solid blue; */
`;

const Box = styled.div`
  background-color: var(--primary);
  padding: var(---space);
  height: 170px;
  width: 400px;

  @media ${device.mobileL} {
    max-width: 300px;
  }
`;

const BoxInner = styled.div`
  padding: var(---space);
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`;

export {
  Container,
  SpaceBetween,
  ButtonContainer,
  SwitchContainer,
  CardHeader,
  FlexEnd,
  TableContainer,
  TableButtonsContainer,
  Box,
  BoxContainer,
  BoxInner,
};
